import { createContext, useContext } from "react";

/*
 * 화면 안의 "다른 화면 링크"를 권한에 따라 숨기기 위한 공용 컨텍스트.
 *
 * 왜 컨텍스트인가:
 *   ① userService.getUserAccessRoles 를 화면마다 또 부르면 호출이 화면 수만큼 늘어난다
 *      (이미 Sidebar·App·WorkflowPanel 이 각자 부르고 있다). App 이 한 번 받은 값을 나눠 쓴다.
 *   ② 판정에 필요한 메뉴 트리(TabMenuList)를 페이지가 직접 import 하면 순환 참조가 된다
 *      — TabMenuList 가 그 페이지를 import 하기 때문. 판정은 App 쪽에서 끝내고 결과 함수만 내린다.
 *
 * 사용:
 *   const { isPermitted } = useMenuAccess();
 *   {isPermitted("MP_FLO_CHART") && <MenuItem ... />}
 *   키는 TabMenuList 의 숫자 key 와 reduxKey 둘 다 받는다.
 *
 * 기본값이 () => true 인 이유: 프로바이더 밖(단위 테스트·스토리)에서 렌더해도 기존 동작을 그대로
 *   두기 위함이다. 실제 앱은 App.js 가 항상 감싸므로 이 기본값이 쓰이지 않는다.
 *   권한 조회 전(userAccess=null)에는 프로바이더가 false 를 돌려준다 — 링크가 잠깐 늦게 뜨는 쪽이
 *   권한 없는 링크가 잠깐 보이는 쪽보다 낫다(Sidebar 와 같은 판단).
 */
const MenuAccessContext = createContext({ userAccess: null, isPermitted: () => true });

export const useMenuAccess = () => useContext(MenuAccessContext);

export default MenuAccessContext;
